import type { IconSvgObject } from './types';

const Magnet02Icon: IconSvgObject = [
  ["path", { d: "M16 10V7H20V10M16 10V14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14V10M16 10H20M20 10V14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14V10M8 10V7H4V10M8 10L4 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.375 1.99982L10.5 4.99982H13.5L11.625 7.99982", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Magnet02Icon;
